import { Row, Col, Typography } from "antd";

const ContentLayout = ({ fullpage, children }) => {
  return (
    <Row style={{ padding: "0 20px" }}>
      <Col
        xs={24}
        md={24}
        lg={fullpage ? 24 : { span: 18, offset: 3 }}
        xxl={fullpage ? 24 : { span: 18, offset: 3 }}
      >
        {children}
      </Col>
    </Row>
  );
};

export const ContentTitle = ({ children, description }) => {
  return (
    <div style={{ marginBottom: "25px" }}>
      <div style={{ borderBottom: "1px solid #dedede", marginBottom: "10px" }}>
        <Typography.Title level={2} type="secondary">
          {children}
        </Typography.Title>
      </div>
      {description && (
        <Typography.Paragraph type="secondary">
          {description}
        </Typography.Paragraph>
      )}
    </div>
  );
};

export const PageSection = ({ title, children }) => {
  return (
    <div className="page-section">
      {title && (
        <div className="page-section-title">
          <Typography.Paragraph type="secondary">{title}</Typography.Paragraph>
        </div>
      )}
      {children}
    </div>
  );
};

export default ContentLayout;
